import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import getContext from 'recompose/getContext';
import TopBackground from '../components/TopBackground';
import { getTopBackgroundColour } from '../selectors/screen';
import { getScreenStyles } from '../selectors/layout';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    return {
        backgroundColor: getTopBackgroundColour(state, isCurrentScreen),
        width: getScreenStyles(state, isCurrentScreen).imageWidth,
    };
}
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps))(TopBackground);
